// extracted by mini-css-extract-plugin
module.exports = {"counter":"counterStyles_counter__3hcAy","counterOverLimit":"counterStyles_counterOverLimit__8k_0T"};